import { NgModule } from '@angular/core';
import { CommonAppNameComponent } from './common-app-name.component';
import { CommonModule } from '@angular/common';

@NgModule({
	imports: [
		CommonModule,
	],
	declarations: [
		CommonAppNameComponent,
	],
	exports: [
		CommonAppNameComponent,
	],
})
export class CommonAppNameModule {}
